const users = {
  users: {
    pageHeader: 'Benutzer',
    addNewUser: '+ Neuen Benutzer hinzufügen',
    name: 'Name',
    role: 'Funktion',
    company: 'Unternehmen',
    status: 'Status',
    noUser: '** Keine Benutzer verfügbar **',
    emailMatch: 'Geben Sie denselben Wert bitte erneut ein.',
    validEmail: 'Geben Sie bitte eine gültige E-Mail-Adresse ein.',
    fieldRequired: 'Dieses Feld ist ein Pflichtfeld.',
    userFormHeader: 'Neue Benutzer hinzufügen',
    userProfile: 'Benutzerprofil',
    defaultEmailHelpText: 'Eine E-Mail mit Anleitungen zur Registrierung wird an diese Adresse gesendet.',
    active: 'Aktiv',
    email: 'E-Mail',
    confirmEmail: 'E-Mail bestätigen',
    firstName: 'Vorname',
    lastName: 'Name',
    phoneNumber: 'Telefonnummer',
    preferredLocale: 'Bevorzugte Spracheinstellung',
    units: 'Einheiten',
    addUser: 'Benutzer hinzufügen',
    updateUser: 'Benutzer aktualisieren',
    supportTechnician: 'Support-Techniker',
    profileAdministrator: 'Verwalterprofil',
    profileApprover: 'Profilgenehmiger',
    administrator: 'Verwalter',
    user: 'Benutzer',
    viewOnly: 'Nur anschauen',
    demonstration: 'Demonstration',
    errorMessageLengthPhone: 'Maximal 50 Zeichen zulässig',
    all: 'Alle',
    inactive: 'Inaktiv',
    termsAndServices: 'Nur der Eigentümer des Systems darf Zugang zu seiner Website gewähren. Ohne schriftliche Genehmigung des Systemeigentümers dürfen die Installateure anderen Unternehmen und Nutzern außerhalb ihres Unternehmens keinen Zugang gewähren. Ich habe die %{termsService} und die %{privacyPolicy} von Enphase gelesen und stimme ihnen zu.  Ich verstehe, dass ein Verstoß gegen diese Bedingungen zur Aussetzung oder Kündigung meines Enlighten-Kontos führen kann.',
    privacyPolicy: 'Datenschutzrichtlinie',
    termsService: 'Nutzungsbedingungen',
  }
};

export default users;
